import { buildQueryString, fetchWrapper } from '@/_helpers';

export const callCenterVoicemailsApi = {
    getVoicemails: ({ team: teamId, page = 1, limit = 20 } = {}) => {
        const queryString = buildQueryString({ team: teamId, page, limit });
        return fetchWrapper.get(`call-center/voicemails?${queryString}`);
    },
};
